import { Button, Form, Input, Radio, Space } from "antd";
import to from "await-to-js";
import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";

import { authService } from "../../modules/auth/auth.service";
import style from "./RegisterCompany.module.scss";

import { t } from "i18next";
import { ModalsContext } from "../../context/modals.context";
import { toastService } from "../../utils/toast.service";

export const RegisterCompany = () => {
  const { setError } = useContext(ModalsContext);
  const [identifikator, setIdentifikator] = useState<string | null>(null);
  const [tipO, setTipO] = useState<number | null>(null);

  const navigate = useNavigate();

  const FIELD_LIMIT_MAP = {
    1: { limit: 9, title: t("COMMON.PIB_MORA_DA_SADRZI_DEVET_CIFARA") },
    2: { limit: 9, title: t("COMMON.PIB_MORA_DA_SADRZI_DEVET_CIFARA") },
    8: { limit: 5, title: t("COMMON.JBJKS_MORA_DA_SADRZI_PET_CIFARA") },
    9: { limit: 9, title: t("COMMON.PIB_MORA_DA_SADRZI_DEVET_CIFARA") },
  };

  const activateCompany = async () => {
    if (!identifikator) return;
    const [err, res] = await to(
      authService.activateDrustvo(identifikator, tipO as number)
    );

    if (err || !res.success) return setError(res?.errorMessage);
    toastService.success("TOAST.ACTIVATE_COMPANY_SUCCESS");
    navigate("/chooseCompany");
  };

  const fieldSettings = (FIELD_LIMIT_MAP as any)[tipO || ""];

  const canSubmit =
    identifikator && `${identifikator}`.length === fieldSettings?.limit;

  const onChange = (e: any) => {
    setTipO(e.target.value);
  };

  // pr dru = 1 -> mb
  // preduzetnik = 2 -> mb
  // k javnih sredstava = 8 -> jbkjs
  // ostalo = 9 -> identifikator

  return (
    <div className={style.container}>
      <div className={style.centeredDiv}>
        <h3>{t("COMMON.UNESITE_IDENTIFIKATOR")}</h3>
        <div className={style.inputWrapper}>
          <Radio.Group onChange={onChange} value={tipO}>
            <Space direction="vertical">
              <Radio value={1}>{t("COMMON.PRIVREDNO_DRUSTVO")}</Radio>
              <Radio value={2}>{t("COMMON.PREDUZETNIK")}</Radio>
              <Radio value={8}>{t("COMMON.KORISNIK_JAVNIH_SREDSTAVA")}</Radio>
              <Radio value={9}>{t("COMMON.OSTALO")}</Radio>
            </Space>
          </Radio.Group>

          <Form.Item
            // validateStatus={!canSubmit ? "error" : "success"}
            validateFirst
            help={!canSubmit && tipO && fieldSettings?.title}
          >
            <Input
              onBeforeInput={(event) => {
                //@ts-ignore
                if (!/[0-9]/.test(event.data)) {
                  event.preventDefault();
                }
              }}
              className={style.identifikatorInput}
              value={identifikator as any}
              onChange={(e) => setIdentifikator(e.target.value)}
              name="register-company"
            />
          </Form.Item>
          <Button
            type="primary"
            onClick={activateCompany}
            disabled={!canSubmit}
          >
            {t("COMMON.PRIJAVI")}
          </Button>
        </div>
      </div>
    </div>
  );
};
